export default __webpack_public_path__ + "static/media/image9.566eb548.png";